import React from 'react';
import styled from 'styled-components';
import { localizedTimestamp } from '@card/commonlib';
import { Report } from '@card/types';

export const ErrorText = styled.span`
  color: ${({ theme }) => theme.colorsNew.coralAlert.regular};
`;

export function ReportLastDownload({ status, last_download_at: lastDownloadAt }: Report) {
  switch (status) {
    case 'failed':
      return <ErrorText>Error al generar el reporte</ErrorText>;
    case 'pending':
      return <>En proceso</>;
    case 'finished':
    default:
      return (
        <>{lastDownloadAt ? localizedTimestamp(new Date(lastDownloadAt)) : 'No descargado aún'}</>
      );
  }
}
